import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Lang from "../../userPreferences/staticWords";
import { objToFormData } from "../../algorithms";
import { MemberListItem } from "../../algorithms/listsAlogrithms";
import { resolver } from "../../API/middlewares/resolveRequests";
import Button from "../sharedComponents/buttons/button";
import {
  communityMembers,
  setCommunityMembers,
} from "./../../API/store/actions/admin/communitiesAction";
import { customStyle, styleStart } from "../../algorithms/styleDirection";
import { paths } from "../../paths/paths";
import TextInput from "../sharedComponents/inputs/textInput";
const AddMemberToCommunity = ({ userToken, modalVisible, setModalVisible }) => {
  const communityId = useSelector((state) => state.community.communityId?.id);
  const [users, setUsers] = useState(null);
  useEffect(() => {
    resolver(communityMembers, setUsers, communityId, userToken);
  }, []);
  const [selectedAdmins, setSelectedAdmins] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [members, setMembers] = useState([]);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (users) {
      setSelectedAdmins([...users?.data?.adminMembers]);
      setSelectedMembers([...users?.data?.communityMembers]);
      setAdmins([
        ...users?.data?.allMembers?.filter(
          (admin) =>
            !users?.data?.communityMembers.some(
              (member) => member.memberId == admin.memberId
            )
        ),
      ]);
      setMembers([
        ...users?.data?.allMembers.filter(
          (member) =>
            !users?.data?.adminMembers.some(
              (admin) => admin.memberId == member.memberId
            )
        ),
      ]);
    }
  }, [users]);

  const submit = async () => {
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res = await setCommunityMembers(
      objToFormData({
        CommunityId: parseInt(communityId),
        AdminCommunityMembers: selectedAdmins?.map((item) => item.memberId),
        CommunityMembers: selectedMembers?.map((item) => item.memberId),
      }),
      userToken
    );
    if (res.status <= 206) {
      setModalVisible(!modalVisible);
      setDisable(false);
    } else {
      setDisable(false);
    }
  };

  return (
    <>
      <div className={"d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"}>
        <div className={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}>
          <p className="my-0">{"الاعضاء الرئيسين"}</p>
        </div>

        <div
          className={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
            "TitleCard"
          )}`}
          style={{
            height: "fit-content",
            maxHeight: 250,
          }}
        >
          <div className="d-flex mb-3">
            <TextInput
              containerStyle={"col-9"}
              type={"text"}
              hiddenPlaceholder={"ابحث"}
              onChange={(e) => {
                let searchKey = e.target.value;
                setAdmins(
                  [
                    ...users?.data?.allMembers.filter(
                      (admin) =>
                        ![
                          ...users?.data?.communityMembers,
                          ...selectedMembers,
                        ].some((member) => member.memberId == admin.memberId)
                    ),
                  ].filter((item) => item.memberName.includes(searchKey))
                );
              }}
            />
            {/*  */}
          </div>

          <div className="d-flex flex-column scroll py-3">
            {admins.map((item, index) => {
              let memberPhoto;
              if (item?.memberPhoto != null)
                memberPhoto = `url("${paths.MemberPhoto}${item.memberId}/${item.memberPhoto}")`;
              else memberPhoto = `url("/assets/images/userPlaceholder.png")`;
              return (
                <MemberListItem
                  key={index}
                  id={item.memberId}
                  photo={memberPhoto}
                  index={index}
                  name={item.memberName}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const value = e.target.value;
                    if (checked) {
                      setSelectedAdmins([...selectedAdmins, item]);
                      setMembers(
                        members.filter((item) => item.memberId != value)
                      );
                    } else {
                      setSelectedAdmins(
                        selectedAdmins.filter((item) => item.memberId != value)
                      );
                      setMembers([item, ...members]);
                    }
                  }}
                  values={selectedAdmins.map((item) => item.memberId)}
                  length={admins?.length - index}
                  checked={true}
                  idChar={"B"}
                />
              );
            })}
          </div>
          <div style={{ fontSize: 14, color: "red" }}></div>
        </div>
      </div>
      <div className={"d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"}>
        <div className={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}>
          <p className="my-0">{"الاعضاء"}</p>
        </div>

        <div
          className={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
            "TitleCard"
          )}`}
          style={{
            height: "fit-content",
            maxHeight: 250,
          }}
        >
          <div className="d-flex mb-3">
            <TextInput
              containerStyle={"col-9"}
              type={"text"}
              hiddenPlaceholder={"ابحث"}
              onChange={(e) => {
                let searchKey = e.target.value;
                setMembers(
                  [
                    ...users?.data?.allMembers.filter(
                      (member) =>
                        ![...users?.data?.adminMembers, ...selectedAdmins].some(
                          (admin) => admin.memberId == member.memberId
                        )
                    ),
                  ].filter((item) => item.memberName.includes(searchKey))
                );
              }}
            />
          </div>

          <div className="d-flex flex-column scroll py-3">
            {members.map((item, index) => {
              let memberPhoto;
              if (item?.memberPhoto != null)
                memberPhoto = `url("${paths.MemberPhoto}${item.memberId}/${item.memberPhoto}")`;
              else memberPhoto = `url("/assets/images/userPlaceholder.png")`;
              return (
                <MemberListItem
                  key={index}
                  id={item.memberId}
                  photo={memberPhoto}
                  index={index}
                  name={item.memberName}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    const value = e.target.value;
                    if (checked) {
                      setSelectedMembers([...selectedMembers, item]);
                      setAdmins(
                        admins.filter((item) => item.memberId != value)
                      );
                    } else {
                      setSelectedMembers(
                        selectedMembers.filter((item) => item.memberId != value)
                      );
                      setAdmins([item, ...admins]);
                    }
                  }}
                  values={selectedMembers.map((item) => item.memberId)}
                  length={members?.length - index}
                  checked={true}
                  idChar={"A"}
                />
              );
            })}
          </div>
          <div style={{ fontSize: 14, color: "red" }}></div>
        </div>
      </div>
      <Button
        disable={disable}
        content={disable ? Lang.saving : Lang.save}
        buttonStyleType="solid"
        onClick={() => {
          submit();
        }}
        containerStyle={"my-3 col-3 container"}
      />
    </>
  );
};

export default AddMemberToCommunity;
